import React from 'react'
import { Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'

type PriceAboveRangeNotificationProps = {
  price: number
  minValue: number
  maxValue: number
}

export function PriceAboveRangeNotification({ price, minValue, maxValue }: PriceAboveRangeNotificationProps) {
  const { t, i18n } = useTranslation()

  return (
    <Notification
      type='warning'
      size='medium'
      variant='flat'
      title=''
      message={t('wizard.screen.basicInfo.price.recommendedNotification.priceAboveRange', {
        price: price.toLocaleString(i18n.language),
        minValue: minValue.toLocaleString(i18n.language),
        maxValue: maxValue.toLocaleString(i18n.language),
      })}
    />
  )
}
